import { useCallback, useRef, useState } from 'react'
import { type ParametersFooterState, type WorkflowParametersSectionHandle } from '../../../components/CustomWorkflows/parameters/WorkflowParametersSection'

const NO_FOOTER_STATE: ParametersFooterState = { dirty: false, saving: false, blocked: false }

export const useWorkflowParametersModal = (workflowId: string, onHide: () => void) => {
  const sectionRef = useRef<WorkflowParametersSectionHandle | null>(null)
  const [trackedWorkflowId, setTrackedWorkflowId] = useState(workflowId)
  const [hasParameters, setHasParameters] = useState<boolean | null>(null)
  const [footerState, setFooterState] = useState<ParametersFooterState>(NO_FOOTER_STATE)

  if (workflowId !== trackedWorkflowId) {
    setTrackedWorkflowId(workflowId)
    setHasParameters(null)
    setFooterState(NO_FOOTER_STATE)
  }

  const onHasParameters = useCallback((has: boolean) => setHasParameters(has), [])
  const handleHide = useCallback(() => {
    if (footerState.dirty && !window.confirm('Discard unsaved parameter changes?')) {
      return
    }
    onHide()
  }, [footerState.dirty, onHide])

  return {
    hasParameters,
    modalProps: {
      onHide: handleHide,
      size: hasParameters ? ('lg' as const) : undefined,
      showFooterActions: Boolean(hasParameters),
      footerPrimaryActionTitle: 'Save',
      footerPrimaryActionLoading: footerState.saving,
      footerPrimaryActionDisabled: !footerState.dirty || footerState.saving || footerState.blocked,
      onFooterPrimaryAction: () => void sectionRef.current?.save(),
    },
    sectionProps: { ref: sectionRef, onHasParameters, onFooterStateChange: setFooterState },
  }
}
